export default {
  backList: '返回列表',
  resetRobot: '复位机器人',
  startRun: '开始执行',
  subtitle: '{flow}{pickPart}{chkPart} · 订单 {order}',
  subtitlePick: ' · 拣选工位 {pickSt}（播种架 {wall}）',
  subtitleChk: ' · 复核工位 {chkSt}',
  infoTitle: '任务信息',
  kTaskNo: '任务号',
  kFlow: '业务流程',
  kStep: '当前步骤',
  kOrder: '订单号',
  kPickSt: '拣选工位',
  kChkSt: '复核工位',
  kPos: '停靠位',
  kFullBay: '完整架位码',
  kFrames: '播种架占用',
  kQty: '商品件数',
  kDevice: '执行设备',
  kCreated: '创建时间',
  kProg: '当前进度',
  qtyUnit: '{n} 件',
  framesUnit: '{n} / 36 框',
  pickStVal: '{id} · 播种架 {wall}',
  naFlow: '—（本流程不涉及）',
  camHead: '头部摄像头',
  camWrist: '腕部摄像头',
  camStation: '工位固定摄像头',
  camFrameShelf: '播种架',
  camStandby: '待机',
  camWorking: '作业中',
  camPaused: '已暂停',
  camDone: '已完成',
  camStop: '已停机',
  mapTitle: '地图导航',
  mapHint: '实时显示机器人、货架、路径与导航点',
  mapUnpack: '拆包上货区',
  mapWork: '拣选 / 复核区（机器人工作区）',
  mapShip: '物流配送区',
  mapShelf1: '01 号货架',
  mapShelf2: '02 号货架',
  mapCheck: '复核工位',
  mapAgv: 'AGV 接驳位',
  mapStation: '复核工位 RC-01',
  mapPickQty: '{done} / {total} 件',
  logTitle: '实时日志',
  logTitleHistory: '历史日志',
  logClear: '清空',
  logEmpty: '等待作业事件...',
  ivTitle: '人工介入',
  ivNeedConfirm: '需人工确认',
  ivRecord: '记录放行',
  ivNone: '无异常',
  ivHasError: '有异常',
  ivOccur: '发生环节：{step}',
  ivRobot: '机器人动作',
  ivReport: '上报路径',
  ivRecovery: '恢复条件',
  ivFoot: '请在「异常处理」中按类型选择处置方式，或点击下方按钮立即处理。',
  ivSafeTip: '机器人作业正常进行中，无遗留商品，齐套校验通过，无需人工介入。',
  ivWait: '待人工确认',
  ivWaitVal: '0 项',
  ivPickDone: '拣选完成',
  ivPickVal: '{done} / {total} 件',
  chainTitle: '机器人动作链',
  chainHintAll: '单件拣选任务（sorting_item · 步骤 0–7）按件数循环，齐套后执行推筐收尾（sorting_finish · 步骤 8–9） · 蓝＝单件拣选、紫＝推筐收尾 · 状态：待执行 / 执行中 / 成功 / 失败',
  chainHintPick: '仅拣选任务：执行单件拣选（步骤 0–7）按件数循环，齐套后执行推筐收尾（步骤 8–9）',
  chainHintChk: '仅复核任务：不展示拣选动作链（单件拣选 / 推筐收尾）',
  chainHintHang: '异常已挂起于 {step} · 闭环后任务自动继续推进',
  chainHintResume: '处置已闭环，任务自动继续推进',
  injectPlaceholder: '演示：注入异常…',
  injectBtn: '注入',
  legendPick: '单件拣选（左侧蓝条）',
  legendCheck: '推筐收尾（左侧紫条）',
  legendDone: '已完成（绿色）',
  legendPending: '未完成（灰色）',
  legendScroll: '横向滚动查看全部步骤',
  chainItemProgress: '第 {done}/{total} 件',
  pickTitle: '拣选执行记录',
  pickHint: '波次内 {total} 个 SKU · 已分播 {done} 个 · 待拣 {pending} 个',
  pickHintOff: '本任务为仅复核，拣选记录不参与',
  pickSkuDim: 'SKU 维度',
  pickSkuCnt: '按商品汇总',
  pickOrdDim: '订单维度',
  pickOrdCnt: '按订单汇总',
  pickOffEmpty: '本任务不涉及拣选步骤',
  colIdx: '#',
  colSku: 'SKU',
  colGoods: '商品',
  colNeedPick: '应拣',
  colDonePick: '已分播',
  colResult: '结果',
  resultDone: '已分播',
  resultDoing: '拣选中',
  resultPending: '待拣',
  colOrder: '订单号',
  colFrame: '播种框',
  colNeedPut: '应投',
  colProgBar: '进度',
  checkTitle: '复核执行记录',
  checkHint: '待复核 {total} 个订单 · 已核 {done} 个 · 异常 {err} 个',
  checkHintOff: '本任务为仅拣选，复核记录不参与',
  checkOffEmpty: '本任务不涉及复核步骤',
  checkNote: '订单号与播种框一一对应 —— 一个订单在播种架上只占一个框，复核时按该框整框核对。',
  colNeedChk: '应核',
  colRealChk: '实核',
  colJudge: '判定',
  colHandle: '处置',
  judgeOk: '一致',
  judgeQty: '数量不符',
  judgeDoing: '复核中',
  judgePending: '待复核',
  handlePending: '待处置',
  handleTitle: '异常处理',
  handleHint: '异常分两级：阻断级挂起等人工闭环，记录级留痕放行不停机',
  hdPending: '异常待处置 · {name}',
  hdClosed: '异常已闭环 · {name}（处置方式：{mode}）',
  hdNone: '当前无待处置异常',
  hdPendingCnt: '异常待处置 · 共 {n} 条',
  gradeBlock: '阻断级',
  gradeRecord: '记录级',
  ruleAction: '机器人动作',
  ruleReport: '上报路径',
  ruleRecovery: '恢复条件',
  rulePolicy: '处置规则',
  rulePolicyText: '异常不中断整个波次：先挂起当前 SKU 或当前订单、保留现场、等人工决策，事后必须留痕。闭环后从挂起点继续推进。',
  hdItem: '异常商品',
  hdStep: '异常环节',
  hdTime: '发生时间',
  hdDur: '已暂停',
  hdState: '处置状态',
  /** 异常子任务字段（接口 /zm/son_tasks） */
  excFieldId: '子任务 ID',
  excFieldType: '任务类型',
  excFieldStatus: '状态',
  excFieldTaskId: '任务号',
  excFieldOrderId: '订单号',
  excFieldSkuId: 'SKU',
  excFieldErrorMessage: '异常信息',
  excFieldCreateTime: '创建时间',
  excFieldUpdateTime: '更新时间',
  excTypePick: '拣选',
  excTypeCheck: '复核',
  excTypeAll: '全流程',
  excStatusPending: '待执行',
  excStatusRunning: '运行中',
  excStatusDone: '已完成',
  excStatusError: '异常',
  statePending: '待处置',
  stateRecord: '记录放行',
  stateClosed: '已闭环 · {mode}',
  stateStop: '已终止',
  modePlaceholder: '选择处置方式…',
  notePlaceholder: '处置说明，例：实核少 1 件，需回退拣选补拣',
  submitHandle: '提交处置',
  stopTask: '终止任务',
  hdLogTitle: '异常记录',
  hdLogEmpty: '暂无异常记录',
  uvTitle: '未校验放行记录',
  uvHint: '记录级异常（商品码 / 箱码不可读）的留痕，不放行阻断但可查、可复盘',
  uvCnt: '共 {n} 条',
  uvEmpty: '暂未校验记录',
  colHdTime: '处置时间',
  colHdItem: '商品',
  colHdType: '异常类型',
  colHdAction: '机器人动作',
  colHdReport: '上报路径',
  colHdMode: '处置方式',
  colHdNote: '说明',
  colHdFb: '反馈',
  colExcCreateTime: '创建时间',
  colExcUpdateTime: '更新时间',
  colExcSkuId: 'SKU',
  colExcOrderId: '订单号',
  colExcType: '类型',
  colExcStatus: '状态',
  colExcErrorMessage: '异常信息',
  colExcId: '子任务 ID',
  colUvTime: '记录时间',
  colUvType: '异常类型',
  colUvBay: '架位',
  colUvBin: '箱位',
  colUvReason: '失败原因',
  colUvRetry: '重试',
  colUvRisk: '风险',
  riskHigh: '高风险',
  riskNormal: '一般',
  fbNone: '未反馈',
  fbOk: '已反馈',
  missing: '未找到任务 {no}',
  toastReset: '已下发复位指令',
  toastNeedExc: '请先选择要注入的异常类型',
  toastInjectFlow: '该异常不属于当前流程（{flow}）',
  toastInject: '已注入异常：{name}，请前往「异常处理」闭环',
  toastNeedMode: '请先选择处置方式',
  toastHandled: '处置已提交，任务继续推进',
  toastStopped: '任务已终止',
  toastDone: '任务执行完成',
  mapHang: '已挂起',
  mapStop: '已终止',
  statusStop: '已终止',
}
